import React, { useContext, useState, createContext } from "react"
import Header from "../../layouts/Header"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Checkbox } from "@mui/material"
import BackIcon from "../../components/BackIcon"
import { useNavigate } from "react-router-dom"
import CustomConditionalActionsTableServer from "../../components/CustomConditionalActionsTableServerSide"
import { GlobalContext } from "../../contexts/GlobalContext"
import { showWarning } from "../../api"
import getIconComponent from "../utils/getIconComponent"
import {
  handleExportDataPdfLGScreen,
  handleExportDataPdfSMScreen,
  handleAllExportDataCSV,
} from "../utils/reactTableActions/exportToolbarActions"

// 1. CREAMOS UN CONTEXTO LOCAL PARA ROMPER LA MEMOIZACIÓN DE LA TABLA
const SelectionContext = createContext()

const StyledRootStyles = {
  display: "flex",
  flexDirection: "column",
  marginTop: "64px",
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}

const theme = createTheme({
  palette: { primary: { main: "#196C87" }, secondary: { main: "#2E7D32" } },
})

const AsignaciondeCartera = () => {
  const navigate = useNavigate()
  const { selectedMenuInfo } = useContext(GlobalContext)

  const [selectedCuotas, setSelectedCuotas] = useState([])

  const handleToggleRow = (row) => {
    const isSelected = selectedCuotas.some(
      (c) =>
        String(c.facnumfac).trim() === String(row.facnumfac).trim() &&
        String(c.facsecuen).trim() === String(row.facsecuen).trim(),
    )
    if (isSelected) {
      setSelectedCuotas((prev) =>
        prev.filter(
          (c) =>
            !(
              String(c.facnumfac).trim() === String(row.facnumfac).trim() &&
              String(c.facsecuen).trim() === String(row.facsecuen).trim()
            ),
        ),
      )
    } else {
      setSelectedCuotas((prev) => [...prev, row])
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 20px 30px",
            fontSize: "25px",
            textAlign: "center",
          }}
        >
          <b>Asignación y Distribución de Cartera</b>
        </div>

        <Box sx={StyledRootStyles}>
          {/* 2. ENVOLVEMOS LA TABLA EN EL CONTEXTO PROVEYENDO EL ESTADO ACTUAL */}
          <SelectionContext.Provider value={{ selectedCuotas, handleToggleRow }}>
            <CustomConditionalActionsTableServer
              endpoint="/AsignaciondeCartera/getAllCarteraDisponible"
              errorMsgFilterSearch="Error al cargar el listado de cartera"
              queryKeyModal={`Cartera_Completa`}
              perPage={10}
              rowActionsWidthTable={120}
              rowActions={(row) => {
                const asignarAction = selectedMenuInfo?.data?.barraAcciones?.find(
                  (a) => a.acccaption === "ASIGNAR" || a.acccaption === "EDITAR" || a.acccaption === "CREAR",
                )
                const actions = []
                if (asignarAction) {
                  actions.push({
                    label: "Asignar Individual",
                    key: "asignar",
                    icon: getIconComponent(asignarAction.accnameicono, asignarAction.acctipoico),
                    onClick: (row) => navigate("asignar", { state: { cuotasSeleccionadas: [row.original] } }),
                  })
                }
                return actions
              }}
              topToolbarCustomActions={({ table, device }) => {
                const acciones = selectedMenuInfo?.data?.barraAcciones || []
                const toolbarActions = []

                const marcarAction = acciones.find((a) => a.acccaption === "MARCARTODOS")
                if (marcarAction) {
                  toolbarActions.push({
                    label: "Seleccionar Todos",
                    key: "marcarTodosBtn",
                    icon: getIconComponent(marcarAction.accnameicono, marcarAction.acctipoico),
                    onClick: () => {
                      const rows = table.getRowModel().rows.map((r) => r.original)
                      const newSelection = [...selectedCuotas]
                      rows.forEach((rowData) => {
                        const exists = newSelection.some(
                          (c) =>
                            String(c.facnumfac).trim() === String(rowData.facnumfac).trim() &&
                            String(c.facsecuen).trim() === String(rowData.facsecuen).trim(),
                        )
                        if (!exists) newSelection.push(rowData)
                      })
                      setSelectedCuotas(newSelection)
                    },
                  })
                }

                const desmarcarAction = acciones.find((a) => a.acccaption === "DESMARCARTODOS")
                if (desmarcarAction) {
                  toolbarActions.push({
                    label: "Quitar Selección",
                    key: "desmarcarTodosBtn",
                    icon: getIconComponent(desmarcarAction.accnameicono, desmarcarAction.acctipoico),
                    onClick: () => setSelectedCuotas([]),
                  })
                }

                const asignarAction = acciones.find(
                  (a) => a.acccaption === "ASIGNAR" || a.acccaption === "CREAR" || a.acccaption === "EJECUTAR",
                )
                if (asignarAction) {
                  toolbarActions.push({
                    label: `Asignación Masiva (${selectedCuotas.length})`,
                    key: "asignacionMasivaBtn",
                    icon: getIconComponent(asignarAction.accnameicono, asignarAction.acctipoico),
                    onClick: () => {
                      if (selectedCuotas.length === 0) {
                        showWarning("Seleccione al menos una cuota marcando las casillas de la tabla.")
                        return
                      }
                      navigate("asignar", { state: { cuotasSeleccionadas: selectedCuotas } })
                    },
                  })
                }

                const exportarAction = acciones.find((a) => a.acccaption === "EXPORTAR")
                if (exportarAction) {
                  toolbarActions.push({
                    type: "dropdown",
                    label: exportarAction.acccaption,
                    key: "exportDropdown",
                    icon: getIconComponent(exportarAction.accnameicono, exportarAction.acctipoico),
                    actions: [
                      {
                        label: "Exportar PDF",
                        key: "pdf",
                        onClick: ({ columns, data }) => {
                          const title = `Reporte de Cartera`
                          device === "sm"
                            ? handleExportDataPdfSMScreen(columns, data, title, title)
                            : handleExportDataPdfLGScreen(columns, table.getCoreRowModel().rows, title, title)
                        },
                      },
                      {
                        label: "Exportar CSV",
                        key: "csv",
                        onClick: ({ data }) => handleAllExportDataCSV(data, `Cartera_SIAC`),
                      },
                    ],
                  })
                }

                return toolbarActions
              }}
              columnsTable={[
                {
                  accessorKey: "seleccion",
                  header: "Sel.",
                  size: 60,
                  enableColumnFilter: false,
                  Cell: ({ row }) => {
                    // 3. LA CELDA CONSUME EL CONTEXTO LOCAL PARA FORZAR SU ACTUALIZACIÓN VISUAL
                    const { selectedCuotas, handleToggleRow } = useContext(SelectionContext)

                    const isSelected = selectedCuotas.some(
                      (c) =>
                        String(c.facnumfac).trim() === String(row.original.facnumfac).trim() &&
                        String(c.facsecuen).trim() === String(row.original.facsecuen).trim(),
                    )

                    return (
                      <Checkbox
                        checked={isSelected}
                        onClick={(e) => e.stopPropagation()}
                        onChange={() => handleToggleRow(row.original)}
                      />
                    )
                  },
                },
                {
                  accessorKey: "estado_asignacion",
                  header: "Estado",
                  size: 130,
                  Cell: ({ cell }) => {
                    const val = cell.getValue()
                    return (
                      <span style={{ fontWeight: "bold", color: val === "SIN ASIGNAR" ? "#b71c1c" : "#196C87" }}>
                        {val}
                      </span>
                    )
                  },
                },
                { accessorKey: "facnumfac", header: "Factura", size: 130 },
                { accessorKey: "facsecuen", header: "Cuota", size: 80 },
                { accessorKey: "clicodigo", header: "Cód. Cliente", size: 100 },
                { accessorKey: "clinombre", header: "Cliente", size: 250 },
                {
                  accessorKey: "condicion_vencimiento",
                  header: "Condición",
                  size: 130,
                  Cell: ({ cell }) => {
                    const val = cell.getValue()
                    return (
                      <span style={{ fontWeight: "bold", color: val === "VENCIDA" ? "#b71c1c" : "#2E7D32" }}>
                        {val}
                      </span>
                    )
                  },
                },
                { accessorKey: "facfecven", header: "F. Vencimiento", size: 120 },
                {
                  accessorKey: "factotal",
                  header: "Total",
                  size: 100,
                  Cell: ({ cell }) => <span>${Number(cell.getValue() || 0).toFixed(2)}</span>,
                },
                {
                  accessorKey: "facsaldo",
                  header: "Saldo a Cobrar",
                  size: 130,
                  Cell: ({ cell }) => (
                    <span style={{ fontWeight: "bold", color: "#b71c1c" }}>
                      ${Number(cell.getValue() || 0).toFixed(2)}
                    </span>
                  ),
                },
                {
                  accessorKey: "usrrecaudador",
                  header: "Recaudador Asignado",
                  size: 160,
                  Cell: ({ cell }) => {
                    const val = cell.getValue()
                    return val ? (
                      <span style={{ color: "#196C87", fontWeight: "bold" }}>{val}</span>
                    ) : (
                      <span style={{ color: "#9e9e9e", fontStyle: "italic" }}>-</span>
                    )
                  },
                },
              ]}
            />
          </SelectionContext.Provider>
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default AsignaciondeCartera
